import sortBy from 'lodash.sortby'
import { mapActions, mapGetters } from 'vuex'

import Inventory from '@/components/Inventory'
import BackpackItem from '@/components/BackpackItem'
import { debounce } from '@/utils'

// TODO this file is really fucking dumb tbh, opposite of what a mixin should be
export default {
  components: {
    Inventory,
  },
  data() {
    return {
      loading: {
        inventory: false,
      },
      inputs: {
        search: '',
      },
      items: [],
    }
  },
  computed: {
    ...mapGetters({
      conga: 'conga/conga',
      inventory: 'user/inventory',
      user: 'user/session',
    }),
    itemComponent() {
      return BackpackItem
    },
    invValue() {
      return this.items.reduce((acc, i) => acc + i.price, 0)
    },
    selected() {
      return this.items.filter(i => i.selected)
    },
    selectedValue() {
      return this.selected.reduce((acc, i) => acc + i.price, 0)
    },
    filteredItems() {
      let items = [...this.items]
      const { search } = this.inputs

      if (search !== '') {
        items = items.filter(i => i.name.toLowerCase().includes(search.toLowerCase()))
      }

      return items
    },
  },
  watch: {
    inventory: {
      handler(inv) {
        this.items = sortBy(
          inv.filter(i => i.canSelect('bet')).map(i => i.$toJson()),
          'price',
        ).reverse()
      },
      immediate: true,
    },
  },
  mounted() {
    this.onGetInventory()
  },
  methods: {
    ...mapActions({
      getInventory: 'user/getInventory',
    }),
    async onGetInventory() {
      if (Object.values(this.loading).some(Boolean)) return

      try {
        this.loading.inventory = true
        await this.getInventory()
      } catch (error) {
        this.$toast.error(error.message)
      } finally {
        this.loading.inventory = false
      }
    },
    onSelectItem(item) {
      if (Object.values(this.loading).some(Boolean)) return
      if (!item.price) return
      if (!item.canBet) return

      // eslint-disable-next-line no-param-reassign
      item.selected = !item.selected
    },
    onSearchInput: debounce(function onChange(search) {
      this.inputs.search = search.trim()
    }, 200),
  },
}
